/** @format */

const PageTranslations = {
  en: {
    'Page.Home.title': 'Welcome on WeMi',
    'Page.Showcase.title': 'Showcase page',
    'Page.Login.title': 'Login page',
    'Page.Login.button.submit': 'Login',
    'Page.NotFound.title': 'Ops! Page not found :(',
  },
  it: {
    'Page.Home.title': 'Benvenuto su WeMi',
    'Page.Showcase.title': 'Pagina galleria',
    'Page.Login.title': 'Pagina login',
    'Page.Login.button.submit': 'Accedi',
    'Page.NotFound.title': 'Ops! Pagina non trovata :(',
  },
};

export default PageTranslations;
